import { ROLE_LABELS, isRole } from '@/features/auth/roles';

/** Roles that can be invited or given on the staff record (not super admin). */
export const ROLES: { value: string; label: string; allBranches: boolean }[] = [
  { value: 'front_desk', label: 'Front desk', allBranches: false },
  { value: 'doctor', label: 'Doctor', allBranches: false },
  // RL-1789: nurses can be invited.
  { value: 'nurse', label: 'Nurse', allBranches: false },
  { value: 'locum', label: 'Locum', allBranches: false },
  { value: 'mental_health', label: 'Mental health', allBranches: false },
  { value: 'lab', label: 'Lab', allBranches: false },
  { value: 'dispenser', label: 'Dispenser', allBranches: false },
  { value: 'finance', label: 'Finance', allBranches: true },
  {
    value: 'clinic_manager',
    label: 'Admin / clinic manager',
    allBranches: true,
  },
];

/** Midnight in Malaysia after the chosen last day (UTC+8). */
export const endOfDayMyt = (ymd: string) =>
  new Date(Date.parse(`${ymd}T00:00:00+08:00`) + 86_400_000).toISOString();

/** A role key in the words staff see on sign-in (e.g. "Super admin"). */
export const staffRoleName = (role: string) =>
  isRole(role)
    ? ROLE_LABELS[role]
    : role.replaceAll('_', ' ').replace(/^./, (c) => c.toUpperCase());

/** The account status in words, never the raw `active` (RL-1793, #154). */
export const staffStatusWords = (status: string) =>
  status === 'active'
    ? 'Active'
    : status === 'suspended'
      ? 'Suspended'
      : status.replaceAll('_', ' ').replace(/^./, (c) => c.toUpperCase());

/** Staff list search (name, greeting name or email) and role filter (RL-1793, #155). */
export function filterStaff<
  T extends {
    fullName: string;
    email: string;
    greetingName?: string | null;
    roles?: { role: string }[];
  },
>(rows: T[] | undefined, search: string, role: string): T[] | undefined {
  if (!rows) return rows;
  const words = search.trim().toLowerCase().split(/\s+/).filter(Boolean);
  return rows.filter((s) => {
    const text = [s.fullName, s.greetingName ?? '', s.email]
      .join(' ')
      .toLowerCase();
    if (!words.every((w) => text.includes(w))) return false;
    return !role || (s.roles ?? []).some((r) => r.role === role);
  });
}
